import { Box, Grid } from "@mui/material";
import ImageLoader from "../components/ImageLoader";
import CustomText from "../components/CustomText";
import Footer from "../components/Footer";
import AreasAndServices from "../00-Dashboard/AreasAndServices";
import { useContext } from "react";
import { ScreenContext } from "../context/ScreenContext";
import { Helmet } from "react-helmet-async";

const VisionMission = () => {
  const { isMobile, isDesktop } = useContext(ScreenContext);

  return (
    <>
      <Helmet>
        <title>Misión y Visión | Centro Médico MEDAM</title>
        <meta
          name="description"
          content="Conoce la misión, visión y valores del Centro Médico MEDAM. Brindamos atención médica profesional con calidad, tecnología, cercanía y empatía."
        />
        <meta
          name="keywords"
          content="Centro Médico MEDAM, misión MEDAM, visión MEDAM, valores médicos, atención médica Texcoco"
        />
        <meta
          property="og:title"
          content="Misión y Visión | Centro Médico MEDAM"
        />
        <meta
          property="og:description"
          content="En MEDAM trabajamos para ofrecer atención médica de calidad, con tecnología avanzada y un trato humano hacia nuestros pacientes."
        />
        <meta
          property="og:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Centro_Medico_Medam_Color.png"
        />
        <meta property="og:type" content="website" />
      </Helmet>
      <Box sx={design.BackGroud}>
        <CustomText
          variant="subtitle1"
          color="#FFFFFF"
          text=" Bienvenidos"
          sx={design.Title}
        >
          Bienvenidos a
        </CustomText>
        <ImageLoader
          src="https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Centro_Medico_Medam_Color.png"
          alt="Logo_Centro_Medico_Medam_Color"
          width={isMobile ? 304 : 608}
          height={isMobile ? 95 : 172}
        />
        <CustomText
          variant="subtitle1"
          color="#FFFFFF"
          text="Nos enorgullece ser un centro médica que ofrece"
          sx={design.Description}
        >
          Nos enorgullece ser un centro médica que ofrece
          <br />
          atención cercana y de calidad a nuestros pacientes
        </CustomText>
      </Box>
      <Box sx={design.Box}>
        <CustomText
          variant="subtitle1"
          color="#FFFFFF"
          text=" Bienvenidos"
          sx={design.Title}
        >
          Cuida de tu salud y la de tu familia
        </CustomText>
        <CustomText
          variant="subtitle1"
          color="#FFFFFF"
          text="Nos enorgullece ser un centro médica que ofrece"
          sx={design.Text}
        >
          En el corazón de Medam está nuestro compromiso con el cuidado
          <br />
          de la salud, guiado por valores familiares que destacan la cercanía
          <br />
          y la empatía. Cada consulta y cada servicio están diseñados para
          <br />
          ofrecer una experiencia médica profesional, sin perder el toque
          <br />
          humano que nos define. Nuestro propósito es cuidarte y
          <br />
          acompañarte en cada paso de tu bienestar.
        </CustomText>
        <ImageLoader
          src="https://centromedicomedam.com/IMG/centromedicoMEDAM/servicios_a_domicilio_con_el_centro_medico_MEDAM.png"
          alt="servicios_a_domicilio_con_el_centro_medico_MEDAM"
          width={isMobile ? "92%" : "70%"}
          height={isMobile ? 200 : 503}
        />
        <Grid container mt={5} mb={5}>
          <Grid size={design.Grid1} />
          <Grid size={design.Grid5}>
            <ImageLoader
              src="https://centromedicomedam.com/IMG/centromedicoMEDAM/servicios_a_domicilio_con_el_centro_medico_MEDAM.png"
              alt="servicios_a_domicilio_con_el_centro_medico_MEDAM"
              width={"100%"}
              height={isMobile ? 200 : 433}
            />
          </Grid>
          <Grid size={design.Grid11} />
          <Grid size={design.Grid11} />
          <Grid size={design.Grid5} alignSelf="center" pl={!isMobile && 3}>
            <CustomText
              variant="subtitle1"
              color="#FFFF"
              text="descrip"
              sx={design.Mision}
            >
              <strong>Misión</strong>
              <br />
              Tratar a todos los pacientes como familia bajo la mejor calidad y
              tecnología del mercado.
            </CustomText>
          </Grid>
          <Grid size={design.Grid1} />
          <Grid size={design.Grid1} />

          <Grid size={design.Grid5} alignSelf="center">
            <CustomText
              variant="subtitle1"
              color="#FFFF"
              text="descrip"
              sx={design.Mision}
            >
              <strong>Visión</strong>
              <br />
              Dejar un legado de bienestar y salud para la gente.
            </CustomText>
          </Grid>
          <Grid size={design.Grid11} />

          <Grid size={design.Grid11} />
          <Grid size={design.Grid5} pt={2}>
            <ImageLoader
              src="https://centromedicomedam.com/IMG/centromedicoMEDAM/servicios_a_domicilio_con_el_centro_medico_MEDAM.png"
              alt="servicios_a_domicilio_con_el_centro_medico_MEDAM"
              width={"100%"}
              height={isMobile ? 200 : 433}
            />
          </Grid>
          <Grid size={design.Grid1} />
        </Grid>
      </Box>
      <Box sx={design.BackGroudLgos}>
        <CustomText
          variant="subtitle1"
          color="#FFFFFF"
          text=" Bienvenidos"
          sx={design.Title}
        >
          Bienvenidos a
        </CustomText>
        <CustomText
          variant="subtitle1"
          color="#FFFFFF"
          text=" Bienvenidos"
          sx={design.Description}
        >
          En Medam, nos regimos por una serie de valores
          <br />
          fundamentales que guían nuestra práctica médica
          <br />y nuestra relación con la comunidad:
        </CustomText>
      </Box>
      <Box sx={design.Box}>
        <Grid container mt={5} mb={5}>
          <Grid size={design.Grid1} />
          <Grid size={design.Grid5} alignSelf="center">
            <CustomText
              variant="subtitle1"
              color="#FFFF"
              text="descrip"
              sx={design.Mision}
            >
              <strong>Excelencia médica</strong>
              <br />
              Nos esforzamos por ofrecer atención de la más alta calidad,
              respaldada por la experiencia y el conocimiento de nuestro equipo
              médico
            </CustomText>
          </Grid>
          <Grid size={design.Grid11} sx={{ border: "2px solid transparent" }} />
          <Grid size={design.Grid11} />
          <Grid size={design.Grid5} pt={isMobile && 2}>
            <ImageLoader
              src="https://centromedicomedam.com/IMG/centromedicoMEDAM/servicios_a_domicilio_con_el_centro_medico_MEDAM.png"
              alt="servicios_a_domicilio_con_el_centro_medico_MEDAM"
              width={"98%"}
              height={isMobile ? 250 : 449}
            />
          </Grid>

          <Grid size={design.Grid1} />
          <Grid size={design.Grid11} />
          <Grid size={design.Grid5} pt={isMobile && 2}>
            <ImageLoader
              src="https://centromedicomedam.com/IMG/centromedicoMEDAM/servicios_a_domicilio_con_el_centro_medico_MEDAM.png"
              alt="servicios_a_domicilio_con_el_centro_medico_MEDAM"
              width={"98%"}
              height={isMobile ? 250 : 449}
            />
          </Grid>
          <Grid size={design.Grid11} />
          <Grid size={design.Grid11} />
          <Grid size={design.Grid5} alignSelf="center">
            <CustomText
              variant="subtitle1"
              color="#FFFF"
              text="descrip"
              sx={design.Mision}
            >
              <strong>Cercanía y empatía</strong>
              <br />
              Valoramos las relaciones cercanas con nuestros pacientes,
              brindándoles atención personalizada y mostrando empatía en cada
              interacción.
            </CustomText>
          </Grid>
          <Grid size={design.Grid1} />
          <Grid size={design.Grid1} />
          <Grid size={design.Grid5} alignSelf="center">
            <CustomText
              variant="subtitle1"
              color="#FFFF"
              text="descrip"
              sx={design.Mision}
            >
              <strong>Innovación y mejora continua</strong>
              <br />
              Buscamos constantemente nuevas formas de mejorar nuestros
              servicios y procesos, adoptando tecnologías y prácticas médicas
              innovadoras.
            </CustomText>
          </Grid>
          <Grid size={design.Grid11} />
          <Grid size={design.Grid11} />

          <Grid size={design.Grid5}>
            <ImageLoader
              src="https://centromedicomedam.com/IMG/centromedicoMEDAM/servicios_a_domicilio_con_el_centro_medico_MEDAM.png"
              alt="servicios_a_domicilio_con_el_centro_medico_MEDAM"
              width={"100%"}
              height={isMobile ? 250 : 449}
            />
          </Grid>
        </Grid>
        <ImageLoader
          src="https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Centro_Medico_Medam_Color.png"
          alt="Logo_Centro_Medico_Medam_Color"
          width={isMobile ? 304 : 608}
          height={isMobile ? 95 : 172}
        />
        <AreasAndServices color="#FFF" isMobile={isMobile} />
      </Box>
      <Footer color="#162E84" />
    </>
  );
};

export default VisionMission;

const design = {
  BackGroud: {
    backgroundImage: `url(https://centromedicomedam.com/IMG/centromedicoMEDAM/fachada_principal_del_centro-medico_MEDAM.png)`,
    backgroundPosition: "center",
    height: "84vh",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    flexDirection: "column",
  },
  BackGroudLgos: {
    backgroundImage: `url(https://centromedicomedam.com/IMG/centromedicoMEDAM/backgroundImage_miniLogos_del_centro-medico_MEDAM.jpg)`,
    backgroundPosition: "center",
    height: "84vh",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  Box: {
    backgroundColor: "#162E84",
    marginTop: -2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    flexDirection: "column",
    pt: 10,
  },
  Title: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 28,
      sm: 36,
      md: 50,
      lg: 50,
    },
    fontWeight: 600,
    lineHeight: "normal",
    marginBottom: "2%",
  },
  Description: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 17,
      sm: 18,
      md: 20,
      lg: 20,
    },
    lineHeight: "normal",
    marginTop: "2%",
    padding: 3,
  },
  Text: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 17,
      sm: 18,
      md: 20,
      lg: 20,
    },
    lineHeight: "normal",
    marginBottom: 5,
    padding: 3,
  },
  Mision: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 18,
      sm: 18,
      md: 20,
    },
    lineHeight: "normal",
    textAlign: "left",
  },
  Grid1: { xs: 1, md: 1, xl: 1, lg: 1 },
  Grid5: { xs: 10, md: 5, xl: 5, lg: 5 },
  Grid11: { xs: 1, md: 0, xl: 0, lg: 0 },
};
